module.exports = __webpack_public_path__ + "img/img_02.133f5966.png";